import { cn } from 'src/shared/lib/utils';

interface CsvViewerProps {
  headers?: string[];
  rows?: string[][];
  maxHeight?: string;
  className?: string;
}

/**
 * Read-only CSV viewer component.
 * Displays CSV data in a simple table format.
 * For editable CSV, use CsvEditor instead.
 */
export function CsvViewer({ headers, rows, maxHeight, className }: CsvViewerProps) {
  return (
    <div
      className={cn('overflow-x-auto overflow-y-auto w-full h-full', className)}
      style={maxHeight ? { maxHeight } : undefined}
    >
      <table className="min-w-full divide-y divide-gray-200 text-sm">
        {!!headers?.length && (
          <thead className="bg-gray-50">
            <tr>
              {headers.map((cell, index) => (
                <th
                  key={index}
                  scope="col"
                  className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider sticky top-0 bg-gray-50 z-10"
                >
                  {cell.trim()}
                </th>
              ))}
            </tr>
          </thead>
        )}
        {!!rows?.length ? (
          <tbody className="bg-white divide-y divide-gray-200">
            {rows.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {row.map((cell, cellIndex) => (
                  <td key={cellIndex} className="px-3 py-2 whitespace-nowrap">
                    {cell.trim()}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        ) : (
          <tbody>
            <tr>
              <td className="text-sm text-gray-500 p-3 text-center" colSpan={headers?.length || 1}>
                No data rows to display.
              </td>
            </tr>
          </tbody>
        )}
      </table>
    </div>
  );
}

export default CsvViewer;
